// extracted by mini-css-extract-plugin
module.exports = {"box":"Tooltip_box_3PW3-","tooltip":"Tooltip_tooltip_3U8S-","text":"Tooltip_text_2VMl8"};